import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 40,
  height: 32,
}

const petFriendly = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 41.875 35.852'
  >
    <g fill={color} transform='translate(0 -0.5)'>
      <path
        d='M41.138,245.394a3.139,3.139,0,0,0-3.573-.9l-6.422,2.555a3.824,3.824,0,0,1-2.549.1l-9.862-3.092a6.07,6.07,0,0,0-1.819-.279H13.7a1.079,1.079,0,0,0-.954-.577H10.535v-.025a1.1,1.1,0,0,0-1.1-1.1H1.1a1.1,1.1,0,0,0-1.1,1.1v12.848a1.1,1.1,0,0,0,1.1,1.1H1.86a.614.614,0,0,0,0-1.227H1.227V243.3h8.08V255.89H4.71a.614.614,0,0,0,0,1.227H9.435a1.1,1.1,0,0,0,1.1-1.1v-.025H12.75a1.079,1.079,0,0,0,.949-.566c3.091,1.753,8.394,2.441,11.457,2.7q.444.038.89.038a10.52,10.52,0,0,0,3.713-.674c4.951-1.877,9.161-5.75,11.23-7.891a3.139,3.139,0,0,0,.149-4.206ZM12.6,254.381v.385H10.534V244.422H12.6Zm27.5-5.634c-2,2.068-6.055,5.8-10.783,7.6a9.3,9.3,0,0,1-4.064.561c-7.225-.613-10.292-2.08-11.431-2.84V245h3.083a4.846,4.846,0,0,1,1.452.222l9.86,3.092.021.006a1.409,1.409,0,0,1,.985,1.581l-.014.081a1.4,1.4,0,0,1-1.5,1.142l-8.157-.766a.614.614,0,0,0-.115,1.222l8.157.766c.081.008.162.011.242.011a2.637,2.637,0,0,0,2.582-2.16l.014-.081a2.592,2.592,0,0,0-.227-1.6,5.039,5.039,0,0,0,1.384-.332l6.422-2.555a1.918,1.918,0,0,1,2.088,3.115Zm0,0'
        transform='translate(0 -221.813)'
      />
      <path
        d='M262.524,124.08a.614.614,0,0,0-1.043-.646,6.658,6.658,0,0,0-1,3.509c0,1.75.74,3.854,2.394,4.608a2.014,2.014,0,0,0,.843.195,2.683,2.683,0,0,0,1.459-.55,4.36,4.36,0,0,1,.54-.313,3.161,3.161,0,0,1,2.525,0,5.886,5.886,0,0,1,.673.308,2.822,2.822,0,0,0,2.55.358c1.655-.753,2.4-2.857,2.4-4.608a6.421,6.421,0,0,0-2.056-4.731,7.076,7.076,0,0,0-4.579-1.886,6.456,6.456,0,0,0-3.526.918.614.614,0,1,0,.633,1.051,5.235,5.235,0,0,1,2.858-.742,5.831,5.831,0,0,1,3.774,1.555,5.207,5.207,0,0,1,1.667,3.836c0,1.314-.524,2.966-1.676,3.491-.412.188-.834-.005-1.487-.336a6.879,6.879,0,0,0-.822-.372,4.337,4.337,0,0,0-3.438.039,5.436,5.436,0,0,0-.7.4c-.54.347-.747.445-1.13.271-1.151-.525-1.676-2.177-1.676-3.49A5.434,5.434,0,0,1,262.524,124.08Zm0,0'
        transform='translate(-239.174 -110.023)'
      />
      <path
        d='M296.943,8.575a4.038,4.038,0,1,0-4.038-4.038A4.042,4.042,0,0,0,296.943,8.575Zm0-6.848a2.81,2.81,0,1,1-2.81,2.81A2.814,2.814,0,0,1,296.943,1.727Zm0,0'
        transform='translate(-268.95)'
      />
      <path
        d='M399.054,60.009a3.354,3.354,0,1,0-3.354-3.354A3.358,3.358,0,0,0,399.054,60.009Zm0-5.482a2.127,2.127,0,1,1-2.127,2.127,2.13,2.13,0,0,1,2.127-2.127Zm0,0'
        transform='translate(-363.337 -48.482)'
      />
      <path
        d='M210.175,60.009a3.354,3.354,0,1,0-3.355-3.354A3.358,3.358,0,0,0,210.175,60.009Zm0-5.482a2.127,2.127,0,1,1-2.127,2.127,2.13,2.13,0,0,1,2.127-2.127Zm0,0'
        transform='translate(-189.905 -48.482)'
      />
    </g>
  </svg>
)

export default petFriendly
